query TripAvailableDocumentTypes {
  tripAvailableDocumentTypes {
    nodes {
      id
      documentType
      isAccountingDocument
      _isAppliableDocumentType
    }
  }
}
